// Remark plugin that turns container directives (`:::tip`, `:::info`, `:::note`)
// into a custom <doc-callout> element, which DocsArticle maps to the DocCallout
// React component. remark-directive does the parsing; this plugin only assigns
// the hName/hProperties so react-markdown renders our component with the
// callout type and title as props.
//
// Authoring syntax in the docs markdown:
//   :::tip{title="Premium Feature"}
//   Body markdown here.
//   :::

interface DirectiveNode {
  type: string;
  name?: string;
  attributes?: Record<string, string | null | undefined> | null;
  children?: DirectiveNode[];
  data?: { hName?: string; hProperties?: Record<string, unknown> };
}

// The directive names we treat as callouts. Anything else is left untouched so
// stray `:::something` blocks don't silently render as a callout.
const CALLOUT_TYPES = new Set(['tip', 'info', 'note']);

function transform(node: DirectiveNode): void {
  if (!node.children) return;

  for (const child of node.children) {
    if (
      child.type === 'containerDirective' &&
      child.name &&
      CALLOUT_TYPES.has(child.name)
    ) {
      child.data = {
        ...child.data,
        hName: 'doc-callout',
        hProperties: {
          ...child.data?.hProperties,
          type: child.name,
          title: child.attributes?.title ?? '',
        },
      };
    }
    transform(child);
  }
}

export default function remarkDocCallouts() {
  return (tree: DirectiveNode): void => {
    transform(tree);
  };
}
